/* Opens and closes the rows version's savings breakdown
   (snippets/cart-total-row.liquid): the gold "$X OFF" button under Subtotal
   and the rows list its aria-controls names.

   A custom element for the same reason as the upsell carousel: the drawer and
   the cart page swap their markup in after every cart change, and an element
   upgrades on insertion where a script inside that markup would never run.

   Every page load starts closed. Which lists are open is kept for the page,
   by list id, so a quantity change made with the rows open puts them back
   open — at once, without the animation, which is for the shopper's taps. */
(() => {
  const openLists = new Set();

  class CartSavingsToggle extends HTMLElement {
    connectedCallback() {
      if (this.button) return;
      this.button = this.querySelector("button[aria-controls]");
      if (!this.button) return;
      this.button.addEventListener("click", () => {
        this.setOpen(this.button.getAttribute("aria-expanded") !== "true");
      });
      if (openLists.has(this.button.getAttribute("aria-controls"))) this.setOpen(true, true);
    }

    setOpen(open, instant) {
      const id = this.button.getAttribute("aria-controls");
      const list = document.getElementById(id);
      const panel = list && list.closest(".cart-totals__panel");
      if (!panel) return;
      if (instant) {
        panel.classList.add("is-instant");
        requestAnimationFrame(() => requestAnimationFrame(() => panel.classList.remove("is-instant")));
      }
      this.button.setAttribute("aria-expanded", String(open));
      panel.classList.toggle("is-open", open);
      if (open) openLists.add(id);
      else openLists.delete(id);
    }
  }

  if (!customElements.get("cart-savings-toggle")) {
    customElements.define("cart-savings-toggle", CartSavingsToggle);
  }
})();
